import { Controller } from "@hotwired/stimulus"

// Both derived from the single "#33D1F5" this chart has always used: the hex on the fill, the same
// colour at full alpha on the border. chart_defaults.js still sets the globals this chart inherits
// (legend hidden, Söhne as the default font).
const BAR_COLOR = "#33D1F5"
const BAR_BORDER_COLOR = "rgba(51,209,245,1)"
const GRID_COLOR = "#F6EFE1"

export default class extends Controller {
  static get targets() { return ["canvas"]; }
  static get values() { return { graph: Object }; }

  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.graphValue.labels,
        datasets: [{
          data: this.graphValue.counts,
          backgroundColor: BAR_COLOR,
          borderColor: BAR_BORDER_COLOR,
          borderWidth: 0,
          barThickness: 24
        }]
      },
      options: this.chartOptions()
    });
  }

  disconnect() {
    if (this.chart) { this.chart.destroy(); }
  }

  // scaleBeginAtZero, barShowStroke, tooltipTemplate and scaleLabel are Chart.js 1 options that
  // version 2 never reads, and scaleLabel is the only thing that has ever looked at answer_count.
  // They are carried over because the page shipped them, not because anything draws from them.
  chartOptions() {
    const answerCount = this.graphValue.answer_count;

    return {
      animation: false,
      scaleBeginAtZero: true,
      responsive: true,
      maintainAspectRatio: false,
      barShowStroke: false,
      scaleLabel: valueObj => `${Math.round(valueObj.value / answerCount * 100)}%`,
      tooltipTemplate: "<%= value %>",
      scales: {
        yAxes: [{
          gridLines: {
            color: GRID_COLOR,
            drawBorder: false,
            borderDash: [8, 8]
          },
          ticks: {
            display: true,
            beginAtZero: true,
            suggestedMax: 4,
            suggestedMin: 4,
            maxTicksLimit: 4,
            minStepSize: 1
          }
        }],
        xAxes: [{
          gridLines: {
            color: GRID_COLOR,
            borderDash: [8, 8]
          },
          ticks: {
            fontFamily: "'Söhne', sans-serif",
            fontSize: 14
          }
        }]
      }
    };
  }
}
